import { MouseEvent } from 'react';
import { useAnalytics } from 'edrolo/analytics';
import {
  Popover,
  usePopover,
  ClickAwayListener,
  enums,
  Pill,
  Icon,
  Heading,
  utils as u,
} from 'edrolo-ui';
import { Skill } from '../../../../../../types/Assemblage';

import styles from './styles.scss';

interface SkillCoveragePopoverProps {
  skills: Skill[];
}

export const SkillCoveragePopover = ({ skills }: SkillCoveragePopoverProps) => {
  const { isOpen, anchor, togglePopover, closePopover } = usePopover();

  const { track } = useAnalytics({});

  const handleSkillCoverageClick = (event: MouseEvent<HTMLElement>) => {
    track('skill coverage info tip clicked');
    togglePopover(event);
  };

  return (
    <ClickAwayListener onClickAway={closePopover}>
      <div>
        <Pill
          variant={enums.PillVariant.OUTLINE}
          color={enums.ColorTheme.FOREGROUND}
        >
          Skill coverage
          <button className={styles.button} onClick={handleSkillCoverageClick}>
            <Icon name={enums.Icons.INFO_TIP} />
          </button>
        </Pill>
        <Popover
          isOpen={isOpen}
          anchor={anchor}
          placement={enums.Placement.BOTTOM_END}
          closePopover={closePopover}
        >
          <div className={styles.content}>
            <Heading level={6} className={u.uppercase}>
              Question set covers the following skills:
            </Heading>
            <ul>
              {skills.map((skill) => (
                <li key={skill.id}>
                  <Icon
                    name={enums.Icons.SKILL}
                    color={enums.ColorTheme.PRIMARY}
                  />
                  {skill.name}
                </li>
              ))}
            </ul>
          </div>
        </Popover>
      </div>
    </ClickAwayListener>
  );
};
